import React, { useContext, useEffect, useState } from "react";
import BTable from "react-bootstrap/Table";
import { squadToList } from "../../helpers/squad";
import { SquadContext } from "../../providers/SquadProvider";
import styles from "./index.module.scss";
import { Alert } from "react-bootstrap";

const ListView = ({
  table,
  players,
  onClickRow,
  allowedPosition,
  disallowedTeams,
  isAdmin,
}) => {
  const [squadList, setSquadList] = useState([]);
  const [canBuyPlayer, setCanBuyPlayer] = useState(false);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = table;

  const { squad, teamBalance } = useContext(SquadContext);
  useEffect(() => {
    setSquadList(squadToList(squad));
  }, [squad]);

  useEffect(() => {
    const canBuyPlayer = players?.some(
      (row) =>
        row.position === allowedPosition &&
        !squadList.includes(row.id) &&
        !disallowedTeams.includes(row.teamId) &&
        Number(row.Cost) <= Number(teamBalance),
    );
    setCanBuyPlayer(canBuyPlayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isAdmin && !canBuyPlayer)
    return (
      <Alert className={styles.cantBuy} style={{ opacity: 1 }} variant="danger">
        Ви не можете купити футболіста! Спробуйте продати дорогих футболістів та
        придбати більш дешевих.{" "}
      </Alert>
    );

  return (
    <>
      <BTable striped hover size="sm" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  style={{ fontSize: "1.3rem", textTransform: "uppercase" }}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                style={{
                  cursor: "pointer",
                  opacity:
                    allowedPosition === "all" ||
                    (row.original.position === allowedPosition &&
                      !squadList.includes(row.original.id) &&
                      !disallowedTeams.includes(row.original.teamId) &&
                      Number(row.original.Cost) <= Number(teamBalance))
                      ? 1
                      : 0.2,
                  pointerEvents:
                    allowedPosition !== "all" &&
                    (row.original.position !== allowedPosition ||
                      squadList.includes(row.original.id) ||
                      disallowedTeams.includes(row.original.teamId) ||
                      Number(row.original.Cost) > Number(teamBalance))
                      ? "none"
                      : "all",
                  fontSize: "1.2rem",
                  lineHeight: "1.5rem",
                }}
                onClick={() => onClickRow(row.original)}
              >
                {row.cells.map((cell) => {
                  return (
                    <td
                      className="align-middle"
                      {...cell.getCellProps({
                        style: {
                          minWidth: cell.column.minWidth,
                          width: cell.column.width,
                        },
                      })}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <nav>
        <ul className="pagination justify-content-end">
          <li
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 16,
              fontSize: "1.3rem",
              lineHeight: "1.3rem",
            }}
          >
            Ст.&nbsp;
            <strong>
              {pageIndex + 1} з {pageOptions.length}
            </strong>{" "}
          </li>
          <li
            className={`darkText page-item page-link ${
              !canPreviousPage && "disabled"
            }`}
            onClick={() => previousPage()}
            style={{ cursor: "pointer", fontSize: "1.3rem" }}
          >
            Попередня
          </li>
          <li
            className={`darkText page-item page-link ${
              !canNextPage && "disabled"
            }`}
            onClick={() => nextPage()}
            style={{ cursor: "pointer", fontSize: "1.3rem" }}
          >
            Наступна
          </li>
        </ul>
      </nav>
    </>
  );
};

export default ListView;
